import { AdditionalInfoStep as SharedAdditionalInfoStep } from "../../../../../shared/additional-info/AdditionalInfoStep";
import type { AccountFormValues } from "../../schema";

export const AdditionalInfoStep = () => (
	<SharedAdditionalInfoStep<AccountFormValues>
		commentPath="account.additionalInfo.comment"
		attachmentsPath="account.additionalInfo.attachments"
	/>
);
